import base from './base';
import palette from "./palette";

const form = {
  MuiFormControlLabel: {
    styleOverrides: {
      root: {
        '&:has(.MuiCheckbox-root.Mui-focusVisible, .MuiCheckbox-root:focus-visible, .MuiRadio-root.Mui-focusVisible, .MuiRadio-root:focus-visible)': {
          backgroundColor: palette.red[100],
          borderRadius: base.shape.borderRadius,
          outline: `1px dashed ${palette.primary.main}`,
        },
      },
      label: {
        fontSize: '14px',
      },
      labelPlacementEnd: {
        marginBottom: 8,
        marginLeft: -2,
        paddingRight: 2,
        '.MuiButtonBase-root': {
          paddingBlock: 2,
          paddingRight: 8,
          paddingLeft: 2,
        },
      },
    },
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        margin: '4px 0 0',
        fontSize: '0.75rem',
        lineHeight: 1.2,
      },
    },
  },
};
export default form;
